import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Orphaned',
      type: 'metric',
      content: {
        '{}': {
          name: 'Orphaned',
          value: {
            '{}': {
              quality: 'negative',
              tooltip:
                'Approved requirement with no linked implementation pull request yet.',
              emphasis: {
                'fmt.num': [
                  {
                    '#': {
                      '@': 'orphanedRequirements',
                    },
                  },
                  {
                    ',': true,
                    '.': {
                      always: 0,
                    },
                  },
                ],
              },
            },
          },
          description: 'Requirements with no build evidence at all.',
        },
      },
    },
  },
  subqueries: {
    orphanedRequirements: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@': 'specApprovedAt',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@': 'buildLinks',
              },
              null,
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
        specApprovedAt: {
          ref: {
            attr: 'attr:ent#!requirements#!requirement:!spec',
          },
          target: 'ent:!specs:!spec',
          quantity: 1,
          selection: {
            '@': 'approvalMergedAt',
          },
          subqueries: {
            approvalMergedAt: {
              ref: {
                attr: 'attr:ent#!specs#!spec:!approval_pull_request',
              },
              target: 'ent:!pull_requests:!pull_request',
              selection: {
                '@.': '!merged_at',
              },
            },
          },
        },
        buildLinks: {
          ref: {
            attr: 'attr:ent#!pr_req_links#!pr_req_link:!requirement',
          },
          target: 'ent:!pr_req_links:!pr_req_link',
          selection: {
            '@.': '!id',
          },
        },
      },
    },
  },
}
